import { api } from '..';
import { MparticleAudiencesResponse, SegmentsReadinessResponse } from './types';

export const mparticleApi = api.enhanceEndpoints({ addTagTypes: ['Mparticle'] }).injectEndpoints({
  endpoints: build => ({
    getMparticleAudiences: build.query<MparticleAudiencesResponse, void>({
      query: () => ({
        url: `v1/mparticle/audiences`,
        method: 'GET',
      }),
    }),
    getSegmentsReadiness: build.query<SegmentsReadinessResponse, void>({
      query: () => ({
        url: `v1/mparticle/audiences/readiness`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyGetMparticleAudiencesQuery, useLazyGetSegmentsReadinessQuery } = mparticleApi;
